/** @module csi/widget/MaterialIcon */
define([
    "dojo/_base/declare",
    "dojo/_base/event",
    "dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"dojo/text!./MaterialIcon.html"
], function(declare,event,_WidgetBase,_TemplatedMixin,template) {
	
    return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,
        
        /** @property {string} icon - name of material icon */
		icon: "",

        /** @property {boolean} stopMouseUp - stop mouse up event (for button inserted in drop down list) */
		stopMouseUp: false,

		/**
		 * Extension point for when widget is clicked
		 */
		onClick: null,

		/**
		 * Click event handler
		 * @param {Event} e 
		 */
		_onClick: function(e) {
			const {onClick} = this;

			if (onClick) {
				event.stop(e);
				this.onClick(this.domNode);
			}
		},

		_onMouseUp: function(e) {
			if (this.stopMouseUp){
				event.stop(e);
			}
		},

		/**
		 * Apply icon property to text of root node
		 */
		_setIconAttr: {node: "domNode", type: "innerText"}
    });
});